var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.84667 15.8346C3.46278 15.8346 3.1425 15.7063 2.88583 15.4496C2.62917 15.193 2.50056 14.8724 2.5 14.488V5.51464C2.5 5.13075 2.62861 4.81047 2.88583 4.5538C3.14306 4.29714 3.46306 4.16852 3.84583 4.16797H16.1542C16.5375 4.16797 16.8575 4.29658 17.1142 4.5538C17.3708 4.81102 17.4994 5.1313 17.5 5.51464V14.4888C17.5 14.8721 17.3714 15.1924 17.1142 15.4496C16.8569 15.7069 16.5369 15.8352 16.1542 15.8346H3.84667ZM10 10.098L16.6667 5.7388L16.41 5.0013L10 9.16797L3.59 5.0013L3.33333 5.7388L10 10.098Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.9de4dc41026d66c02eebb230fdc359e7.svg";
export { ForwardRef as ReactComponent };